import {
  PAEventType,
  ToggledEvents
} from '@dadohr/shared/domainTypes/productAnalytics';
import { Typography } from '@material-ui/core';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import { useProductAnalytics } from '../../../../services/productAnalytics';

type TrackingInfo = {
  name: ToggledEvents;
  explanation: string;
};

export const GraphUnitSelector = ({
  selectedFilter,
  selectedValue,
  title
}: {
  selectedFilter: string;
  selectedValue: (value: 'byCohort' | 'byMonth' | 'byWeek') => void;
  title: string;
}) => {
  const { trackEvent } = useProductAnalytics();
  const trackingInfo: Record<string, TrackingInfo> = {
    participants: {
      name: 'Participants Chart Toggled',
      explanation:
        'Admin user changed the time/cohort settings for the line chart showing the number of participants who started an experience'
    },
    tasks: {
      name: 'Tasks By Status Chart Toggled',
      explanation:
        'Admin user changed the actor or time/cohort settings for the stacked bar chart showing tasks by status'
    }
  };
  return (
    <ToggleButtonGroup
      onChange={(ev, filter: 'byCohort' | 'byMonth' | 'byWeek' | null) => {
        if (filter === null) {
          return;
        }
        selectedValue(filter);
        Object.keys(trackingInfo).forEach((info: string) => {
          if (info === title) {
            trackEvent({
              eventType: PAEventType.OTHER,
              name: trackingInfo[info].name,
              Explanation: trackingInfo[info].explanation,
              'Toggle Changed': 'Time Unit/Cohort',
              'New Toggle Value':
                filter === 'byCohort'
                  ? 'Cohorts'
                  : filter === 'byMonth'
                  ? 'Months'
                  : 'Weeks'
            });
          }
        });
      }}
      exclusive
      value={selectedFilter}
      aria-label="date filter"
    >
      <ToggleButton
        value={'byCohort'}
        aria-label="cohorts"
        style={{ textTransform: 'capitalize' }}
      >
        <Typography variant="body2">Cohorts</Typography>
      </ToggleButton>
      <ToggleButton
        value={'byWeek'}
        aria-label="weeks"
        style={{ textTransform: 'capitalize' }}
      >
        <Typography variant="body2">Weeks</Typography>
      </ToggleButton>
      <ToggleButton
        value={'byMonth'}
        aria-label="months"
        style={{ textTransform: 'capitalize' }}
      >
        <Typography variant="body2">Months</Typography>
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
